import { Modal } from '@/components';
import { useEffect } from 'react';
import { RiWhatsappLine } from 'react-icons/ri';
import * as S from './styles';

interface Props {
  isOpen: boolean;
  closeModal: () => void;
}

const ModalCreditLimit = ({ isOpen, closeModal }: Props) => {
  useEffect(() => {
    if (isOpen) {
      const timer = setTimeout(() => {
        closeModal();
        window.location.href =
          'https://api.whatsapp.com/send/?phone=556740092800&text&type=phone_number&app_absent=0';
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [isOpen, closeModal]);

  return (
    <Modal
      id="modal-credit-limit"
      isOpen={isOpen}
      closeModal={closeModal}
      showDragHeader={false}
      direction="bottom"
      headerIcon={<RiWhatsappLine />}
      
    >
      <S.Container>
        <S.Header>
            <RiWhatsappLine />
          </S.Header>
        <S.Content>
          <S.Title>Aguarde...</S.Title>
          <S.Message>
            Você está sendo redirecionado para nosso canal no WhatsApp
          </S.Message>
          
          <S.LittleLoadingContainer>
             <S.LittleLoading>
                            <S.LittleLoadingPulse />
                          </S.LittleLoading>
          </S.LittleLoadingContainer>
        </S.Content>
      </S.Container>
    </Modal>
  );
};

export default ModalCreditLimit;

